export default __webpack_public_path__ + "static/media/featureRaceHome.03bff0c7.png";